import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { Project } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

type UpdateAllowedOriginsParams = {
  allowedOrigins: string[];
};

export const useUpdateAllowedOrigins = (
  projectId: string,
  options: Omit<UseMutationOptions<Project, UnprocessableEntityError, UpdateAllowedOriginsParams, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<Project, UnprocessableEntityError, UpdateAllowedOriginsParams, unknown>({
    mutationFn: async ({ allowedOrigins }): Promise<Project> => {
      const response = await api.patch<Project>(`/projects/${projectId}/allowed-origins`, { allowed_origins: allowedOrigins });
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects"],
      });
    },
    ...options
  });
};
